import { z } from 'zod';
import { DecimalString } from './common.js';

/** POST /api/users/convert/rp-sp3 — §8.3 */
export const RpSp3ConvertSchema = z.object({
  amount: DecimalString,
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
  idempotency_key: z.string().max(64).optional(),
});

export type RpSp3ConvertRequest = z.infer<typeof RpSp3ConvertSchema>;
